import {OPENQUERY} from './OpenQueryTypes'

export const setOpenQuery = openQuery => {
    return {
        type: OPENQUERY,
        load: openQuery
    }
}
